

export default {

    /* Default zoom */
    zoom: 7.5,
    
}
